/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coinvestments_Closedeal_Card_Subtitle2Inputs */

const en_coinvestments_closedeal_card_subtitle2 = /** @type {(inputs: Coinvestments_Closedeal_Card_Subtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The current closing date is ${i?.date}`)
};

/**
* | output |
* | --- |
* | "The current closing date is {date}" |
*
* @param {Coinvestments_Closedeal_Card_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_card_subtitle2 = /** @type {((inputs: Coinvestments_Closedeal_Card_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Card_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_card_subtitle2(inputs)
});
export { coinvestments_closedeal_card_subtitle2 as "coInvestments_closeDeal_card_subtitle" }